import flagus from "../assets/images/flags/us.svg";
import flagrussia from "../assets/images/flags/russia.svg";
import flaguz from "../assets/images/flags/uz.svg";

const languages = {
  rs: {
    label: "Русский",
    flag: flagrussia,
  },
  en: {
    label: "English",
    flag: flagus,
  },
  uz: {
    label: "O'zbekcha",
    flag: flaguz,
  },
  uzc: {
    label: "Ўзбекча",
    flag: flaguz,
  },
};

export default languages;
